import React, { Component } from 'react';
import './PrimaryButtonIcon.scss';

class PrimaryButtonIcon extends Component<{ text: string, icon: any, action?: any, style?: any }, {}> {

  /**
   * Main render method
   */
  render() {
    return (
      <div className="primary-icon" style={this.props.style} onClick={() => {
        if (this.props.action) {
          this.props.action();
        }
      }}>
        <img src={this.props.icon} className="icon" alt="icon"/>
        <div className="primary-text">{this.props.text}</div>
      </div>
    );
  }
}

export default PrimaryButtonIcon;